import { ModuleTime } from "../../../../../design-system/components/ModuleTime/ModuleTime.jsx";
import type { SparkModule } from "../../../../../api/spark";
import styles from "./StepDuration.css";

/**
 * The minutes to show for `step`, or null when there is nothing to show.
 *
 * The first step of a multi-step station shows the whole station's total;
 * every other step shows its own time.
 */
const getStepDurationMins = (
  step: SparkModule,
  stationSteps: SparkModule[] | null | undefined,
): number | null => {
  const isInMultiStepStation = Boolean(stationSteps && stationSteps.length > 1);
  // By key: `step` and `stationSteps` come from separate fetches.
  const isFirstStationStep =
    isInMultiStepStation && stationSteps?.[0]?.key === step.key;

  if (!isFirstStationStep) return step.recommendedMinutes || null;

  const stationTotalMins = (stationSteps ?? []).reduce(
    (sum, stationStep) => sum + stationStep.recommendedMinutes,
    0,
  );
  return stationTotalMins || null;
};

/**
 * Shows how long a step takes. Renders nothing if no duration is available.
 */
export const StepDuration = ({
  step,
  stationSteps,
}: {
  step: SparkModule;
  stationSteps?: SparkModule[] | null;
}) => {
  const durationMins = getStepDurationMins(step, stationSteps);
  if (durationMins === null) return null;
  return (
    <span className={styles.duration}>
      <ModuleTime duration={durationMins} />
    </span>
  );
};
